export const normalizeGoogleAddress = (place) => {
  if (!place?.address_components) return {};

  const get = (type) =>
    place.address_components.find(c => c.types.includes(type))?.long_name || "";

  return {
    pincode: get("postal_code"),
    city:
      get("locality") ||
      get("administrative_area_level_2"),
    state: get("administrative_area_level_1"),
    areaLocation:
      get("sublocality") ||
      get("route"),
    landmark: ""
  };
};
